export const getUnitSelectOptions = (plan) => {
	return plan.units.map((step) => ({
		label: step.units,
		value: String(step.units),
	}));
};

export const getPaymentIntervalOptions = (getLabel) => {
	return [
		{ label: getLabel('payment_switch_monthly'), value: 'monthly' },
		{ label: getLabel('payment_switch_annually'), value: 'annually' },
	];
};
